import React, { useEffect } from "react";
import "../CSS/contactme.css";
import "../App.css";
import Contactdetailsimg from "../Images/navbar/contactdetails.png";

function Contactme({ setindex }) {
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setindex(5);
        }
      });
    }, options);

    const divs = document.getElementById("contact");
    observer.observe(divs);

    return () => {
      observer.unobserve(divs);
    };
  }, []);
  return (
    <div id="contact" className="contactme">
      <div className="header-block fontbold">
        <img src={Contactdetailsimg} alt="intro" />
        Contact
      </div>
      <br />
      <br />
      <div>
        <div className="page-heading">
          Let's work <span className="namecolor">Together</span>
        </div>
        <br />
        <form
          action="mailto:reshamiyadev1234@gmail.com"
          method="post"
          enctype="text/plain"
        >
          <div className="contact-form">
            <div className="formhead fontbold namecolor">
              reshamiyadev1234@gmail.com
            </div>
            <div>
              <div>Full Name *</div>
              <input
                type="text"
                name="fullname"
                placeholder="Your Name"
                required
              />
            </div>
            <div>
              <div>Email *</div>
              <input type="email" name="email" placeholder="Email" required />
            </div>
            <div>
              <div>Phone Number *</div>
              <input
                type="text"
                name="Phonenumber"
                placeholder="Phone Number"
                required
              />
            </div>
            <div className="formhead">
              <div>Message *</div>
              <textarea
                name="message"
                placeholder="Add your message"
                required
              ></textarea>
            </div>
          </div>
          <br />
          <div className="form-submit-button">
            {" "}
            <input type="submit" value="Send" />
          </div>
        </form>
      </div>
      <br />
      <br />
    </div>
  );
}

export default Contactme;
